export default __webpack_public_path__ + "static/media/water6.45b0d738.png";